export const ENVIRONMENTS = {
  localhost: {
    baseurl: '',
  },
  dev: {
    baseurl: '/api/',
  },
  prod: {
    baseurl: '/api/'
  }
};

export const DEPLOYED_ENVIRONMENT = 'prod';
export const BASE_PATH = '';

